import theme from "@/theme";

export const stylesPurchaseRow = {
  row: {
    display: "flex",
    alignItems: "center",
    padding: "12px 15px 12px 15px",
    borderBottom: "1px solid #F4F5F6",
  },

  leftSection: {
    display: "flex",
    alignItems: "center",
    flex: "1 1 auto",
    minWidth: 0,
  },

  iconWrapper: {
    width: 40,
    height: 40,
    marginRight: "12px",
  },

  title: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "145%",
    color: "#2A2D31",
    marginBottom: "2px",
    cursor: "pointer",
    textDecoration: "underline",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
    maxWidth: "156px",
  },

  date: {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "135%",
    color: "#7D8690",
    letterSpacing: "0.5%",
  },

  centerSection: {
    flex: "0 0 180px",
    width: "180px",
    paddingLeft: "24px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },

  amount: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "145%",
    color: "#2A2D31",
    textAlign: "left",
  },

  sats: {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "135%",
    letterSpacing: "0.5%",
    textAlign: "left",
  },

  feeSection: {
    flex: "0 0 180px",
    width: "180px",
    paddingLeft: "24px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },

  feeText: {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "145%",
    color: "#2A2D31",
    textAlign: "left",
  },

  feeLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#9DA6B0",
    marginLeft: "4px",
  },

  arrowSection: {
    flex: "0 0 90px",
    width: "90px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  arrowIcon: {
    fontSize: 14,
    color: "#9DA6B0",
    cursor: "pointer",
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "90px",
    height: "100%",
  },
  statusBase: {
    borderRadius: "5px",
    padding: "4px 8px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    fontFamily: "Inter",
    textAlign: "center",
    display: "inline-block",
  },

  statusPending: {
    backgroundColor: "#2AAAFF1A",
    color: theme.palette.custom.mainBlue,
  },

  statusCompleted: {
    backgroundColor: "#0080011A",
    color: "#008001",
  },

  statusFailed: {
    backgroundColor: "#FF403D1A",
    color: "#FF403D",
  },
};
